import { PersonIcon } from '@/assets/icons'
import PageLoader from '@components/PageLoader'
import { useBreadcrumbs } from '@context/BreadcrumbContext'
import { useTrip, useTripMembers } from '@hooks'
import React from 'react'
import { useParams } from 'react-router-dom'
import {
    ErrorState,
    MemberCard,
    MemberCardAvatar,
    MemberCardName,
    MembersContainer,
    MembersGrid,
    MembersHeader,
    MembersTitle,
    MembersWrapper,
} from './MembersPage.styles'

const MembersPage: React.FC = () => {
	const { tripId } = useParams<{ tripId: string }>()
	const { data: trip, isLoading: tripLoading } = useTrip(tripId)
	const { data: membersData, isLoading: membersLoading } = useTripMembers(tripId)

	// Set breadcrumbs - must be called before any early returns
	useBreadcrumbs(
		trip
			? [
					{ label: trip.name, path: `/trips/${tripId}` },
					{ label: 'Members' },
				]
			: []
	)

	if (tripLoading || membersLoading) {
		return (
			<MembersWrapper>
				<PageLoader label="Loading members…" />
			</MembersWrapper>
		)
	}

	if (!trip) {
		return (
			<MembersWrapper>
				<MembersContainer>
					<ErrorState>Trip not found</ErrorState>
				</MembersContainer>
			</MembersWrapper>
		)
	}

	const members = membersData?.members || []

	return (
		<MembersWrapper>
			<MembersContainer>
				<MembersHeader>
					<MembersTitle>{trip.name} - Members</MembersTitle>
				</MembersHeader>

				<MembersGrid>
					{members.map(member => (
						<MemberCard key={member.id}>
							<MemberCardAvatar>
								{member.profilePicture ? (
									<img src={member.profilePicture} alt={`${member.firstName} ${member.lastName}`} />
								) : (
									<PersonIcon sx={{ fontSize: 48 }} />
								)}
							</MemberCardAvatar>
							<MemberCardName>
								{member.firstName} {member.lastName}
							</MemberCardName>
						</MemberCard>
					))}
				</MembersGrid>
			</MembersContainer>
		</MembersWrapper>
	)
}

export default MembersPage

